import React from "react"

const defaultState = {
  
}

const OnSiteMarketingContext = React.createContext(defaultState)
export default OnSiteMarketingContext
